import React, { useEffect, useState } from "react";
import {
  getSimpleResults,
  postSimpleSearch
} from "@app/services/frontofficeServices.js";

import ChangePageSize from "@app/plugins/components/results/pagination/ChangePageSize";
import LoadMore from "@app/plugins/components/results/pagination/LoadMore";
import Sort from "@app/plugins/components/results/Sort";
import TilesView from "@app/plugins/components/results/views/TilesView";
import axiosSession from "@app/config/axiosSession";
import useGenericToastify from "@app/hooks/useGenericToastify";
import { useTranslation } from "react-i18next";

const CollectionList = ({
  config: { collection_id: collectionId, detail_view_url: detailViewUrl }
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState("-PL.marc21_publication_date");
  const [items, setItems] = useState([]);
  const [lastPage, setLastPage] = useState(true);
  const [query, setQuery] = useState("");
  const { t } = useTranslation();
  const { notifyError } = useGenericToastify();

  const urls = {
    detailViewUrl: detailViewUrl,
    noImageUrl: "/static/images/no_image.png",
    getCollections: "/api/collections/"
  };

  const getLanguage = () => {
    return (
      t.language ||
      (typeof window !== "undefined" && window.localStorage.i18nextLng) ||
      "PL"
    );
  };

  useEffect(() => {
    setIsLoading(true);
    if (collectionId) {
      axiosSession
        .get(urls.getCollections)
        .then(res => {
          const filteredCollections = res.data.filter(
            elem => elem.id === Number(collectionId)
          );
          const collectionTitle =
            filteredCollections.length === 1
              ? filteredCollections[0].internal_name
              : "";
        })
        .catch(err => console.error(err));
      postSimpleSearch({
        query: collectionId,
        search_type: "collections",
        full_url: "",
        filters: [],
        language: getLanguage().toUpperCase()
      })
        .then(({ data }) => {
          if (query !== data) {
            setPage(1);
            setQuery(data);
          }
        })
        .catch(() => {
          notifyError(t("cms.plugins.advancedSearch.errors.searchFailed"));
        });
    }
  }, [collectionId]);

  useEffect(() => {
    setIsLoading(true);
    if (page === 1) {
      setItems([]);
    }
    const params = {
      limit,
      page,
      sort,
      id: query,
      plugin_id: ""
    };
    if (query) {
      getSimpleResults(params)
        .then(({ data }) => {
          setTotal(data.total);
          setItems(origin => [...origin, ...data.items]);
          setLastPage(data.last_page);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [query, limit, page, sort]);

  return (
    <>
      <div className="btn-group btn-group--panel">
        <Sort
          setPage={setPage}
          setSort={setSort}
          sort={sort}
          disabled={false}
          excludeFilters={["score"]}
        />
        <ChangePageSize setPage={setPage} setLimit={setLimit} />
        <div>
          <span>{`${t(
            "cms.plugins.collection_object_list.results_number"
          )}:`}</span>
          &nbsp;
          <strong>{total}</strong>
        </div>
      </div>
      {items.length > 0 ? (
        <>
          <TilesView items={items} urls={urls} downloadList={[]} />
          <div className="section__content__more">
            <LoadMore
              setPage={setPage}
              isLoading={isLoading}
              isLastPage={lastPage}
            />
          </div>
        </>
      ) : isLoading ? (
        <div className="grid">
          <div className="col-xs-12 col-sm-4"></div>
          <div className="col-xs-12 col-sm-8">
            <p>{t("cms.plugins.results.loading")}</p>
          </div>
        </div>
      ) : (
        <div className="grid">
          <div className="col-xs-12 col-sm-4"></div>
          <div className="col-xs-12 col-sm-8">
            <p>{t("cms.plugins.collection_object_list.no_results")}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default CollectionList;
